export enum EventTypeEnum {
    TenantChanged = "TENANT_CHANGED",
    SignedIn = "SIGNED_IN",
}